import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9fb437a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nr-l-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Apply firmware", -1))
const _hoisted_3 = { class: "p-inputgroup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Dropdown, {
        modelValue: _ctx.selectedFirmware,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFirmware) = $event)),
        options: _ctx.firmwareOptions,
        optionLabel: "name",
        optionValue: "id",
        placeholder: "Select a firmware to upload",
        filter: true,
        onFilter: _ctx.onFilter,
        "filter-placeholder": "Search..."
      }, null, 8, ["modelValue", "options", "onFilter"]),
      _createVNode(_component_Button, {
        icon: "pi pi-list",
        label: "Start",
        onClick: _ctx.upload
      }, null, 8, ["onClick"])
    ])
  ]))
}